import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";

@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    CommonModule,
    IonicModule
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    CommonModule,
    IonicModule
  ]
})

export class SharedModule
{

}